// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { Draft } from "immer";
import merge from "lodash/merge";

export interface XAccountStateType {
    firstName?: string;
    lastName?: string;
    company?: string;
    jobTitle?: string;
    phone?: string;
    isCustomFieldsValid?: boolean;
    properties?: {
        resetPasswordRequired?: string;
    };
}

export const initialAccountState: XAccountStateType = {
    firstName: "",
    lastName: "",
    company: "",
    jobTitle: "",
    phone: "",
    properties: {},
};

const reducer = {
    "xAccountSettings/Update": (draft: Draft<XAccountStateType>, action: XAccountStateType) => {
        draft = merge(draft, action);
    },
};

const xAccount = createTypedReducerWithImmer(initialAccountState, reducer);

(reducers as any).xAccount = xAccount;

export type xAccountState = {
    xAccount: XAccountStateType;
} & ApplicationState;

type xAccountReducers = {
    [key: string]: typeof xAccount;
};

export type xAccountActions = Parameters<xAccountReducers[keyof xAccountReducers]>[1] | AnyAction;
